import './header';
import './footer';
import './petdetails';
import './gauge';
import './fix-findpatient-ui';
import './tooltip';
import './statisticsBox';
import './progressBar';
import './dashboardTile';
import './fieldValidation';
import './pagination';
import './pwr-angucomplete-alt';
import './pro-receipt-upload-angucomplete';
import './v2';
import './numericPagination';
